import React, { useState } from "react";

import WebLayout from "../components/WebLayout";
import {
  Grid,
  Card,
  Typography,
  CardContent,
  Box,
  CircularProgress,
  Link,
} from "@material-ui/core";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useHistory, useParams } from "react-router-dom";

import AspectRatioBox from "../components/AspectRatioBox";
import TitleBox from "../components/TitleBox";
import { useAlert } from "../console/components/Alert";

const GET_HYPNOTIST = gql`
  query GetHypnotist($id: ID!) {
    hypnotist(id: $id) {
      id
      picture {
        filename
        mimetype
        encoding
        location
      }
      email
      address
      line
      facebook
      name
      content
      # "緯度（由 address 於伺服器端 geocode 而來，查不到時為 null）"
      latitude
      # "經度（由 address 於伺服器端 geocode 而來，查不到時為 null）"
      longitude
    }
  }
`;

export default function HypnotistPost() {
  const Alert = useAlert();
  const history = useHistory();
  const { id } = useParams();
  const [hypnotistInput, setHypnotistInput] = useState({
    picture: null,
    email: null,
    address: null,
    line: null,
    facebook: null,
    name: null,
    content: null,
  });
  const [googleMapLocation, setGoogleMapLocation] = useState([]);
  const { loading } = useQuery(GET_HYPNOTIST, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: { id: id },
    onCompleted({ hypnotist }) {
      if (hypnotist) {
        delete hypnotist.picture.__typename;
        setHypnotistInput({
          picture: hypnotist.picture,
          email: hypnotist.email,
          address: hypnotist.address,
          line: hypnotist.line,
          facebook: hypnotist.facebook,
          name: hypnotist.name,
          content: hypnotist.content,
        });
        // 直接使用 gql 回傳的經緯度（伺服器端已完成 geocode），不再於前端呼叫 Geocode。
        if (hypnotist.latitude != null && hypnotist.longitude != null) {
          setGoogleMapLocation([
            {
              lat: hypnotist.latitude,
              lng: hypnotist.longitude,
              title: hypnotist.name,
              id: id,
            },
          ]);
        }
      } else {
        Alert.alert("", "資料載入錯誤！", [
          {
            text: "確定",
            onClick: () => history.replace("/"),
            type: "ok",
          },
          { text: "取消" },
        ]);
      }
    },
  });
  return (
    <WebLayout data={googleMapLocation}>
      {loading ? (
        <Grid container justify="center">
          <CircularProgress color="secondary" />
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid
            container
            item
            xs={12}
            sm={4}
            direction="column"
            alignItems="center"
          >
            <Card style={{ width: "100%", maxWidth: 300 }}>
              <Box margin={1}>
                <AspectRatioBox widthSize={1} heightSize={1}>
                  <img
                    alt=""
                    src={
                      hypnotistInput.picture && hypnotistInput.picture.location
                    }
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </AspectRatioBox>
              </Box>
              <CardContent>
                <Typography align="center">{hypnotistInput.name}</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TitleBox title={"簡介"}>
              <Typography paragraph>
                &emsp;&emsp;
                {hypnotistInput.content &&
                  hypnotistInput.content.split("\n").map((contentData) => (
                    <>
                      <br />
                      <span>{contentData}</span>
                    </>
                  ))}
                <br />
                <span>地&emsp;&emsp;址:&emsp;</span>
                <Link
                  href={`https://www.google.com/maps/search/?api=1&query=${hypnotistInput.address}`}
                  target="_blank"
                  rel="noopener"
                >
                  {hypnotistInput.address}
                </Link>
                <br />
                <span>信&emsp;&emsp;箱:&emsp;</span>
                <Link
                  href={`mailto:${hypnotistInput.email}`}
                  target="_blank"
                  rel="noopener"
                >
                  {hypnotistInput.email}
                </Link>
                <br />
                <span>粉&emsp;&emsp;專:&emsp;</span>
                <Link
                  href={`${hypnotistInput.facebook}`}
                  target="_blank"
                  rel="noopener"
                >
                  {hypnotistInput.facebook}
                </Link>
                <br />
                <span>預約方式:&emsp;</span>
                <span>{hypnotistInput.line}</span>
              </Typography>
            </TitleBox>
          </Grid>
        </Grid>
      )}
    </WebLayout>
  );
}
